import UiStateStore from './stores/ui-state-store';
import ParamStore from '../logic/stores/param-store';
import ModelStore from '../logic/stores/model-store';
import BubblePositionCalculator from './bubble-position-calculator';
import LoginBubble from '../components/login-bubble';
import LoginForm from '../components/login-form';
import TrackingAction from '../constants/tracking-action';
import FormType from '../constants/form-type';
import JmServices from '../ws/jm-services';
import ErrorLogger from '../infrastructure/error-logger';
import FormActions from '../logic/form-actions';
import ParamManager from './params/param-manager';
import CoreParamManager from './params/core-param-manager';

export default class UiActions {

    // Deprecated
    static getClsLoginUrl(componentId) {
        return ParamStore.getModel(componentId).clsLoginUrl;
    }

    // Deprecated
    static createForm(placeHolder, params, componentId) {

        // Deprecated initialization of component
        UiActions.registerComponent(componentId);
        CoreParamManager.validateAndStore(params, componentId);
        ParamManager.validateAndStore(params, componentId);

        UiActions.createFormV2(placeHolder, componentId);
    }

    static createFormV2(placeHolder, componentId) {
        if (ModelStore.getModel(componentId).formType === FormType.register) {
            JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsRegisterViewLoaded});
        }

        UiStateStore.update(componentId, (model) => {
            model.form.formPlaceholder = placeHolder;
        });

        ReactDOM.render(
            <LoginForm componentId={componentId} />,
            UiStateStore.getModel(componentId).form.formPlaceholder
        );
    }

    // Discontinue, no more providing Bubble experience
    static initBubble(placeHolder, params, componentId) {

        // Deprecated initialization of component
        UiActions.registerComponent(componentId);
        CoreParamManager.validateAndStore(params, componentId);
        ParamManager.validateAndStore(params, componentId);

        try {

            window.Object.defineProperty(Element.prototype, 'documentOffsetTop', {
                configurable: true,
                get: () => {
                    return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop : 0);
                }
            });

            window.Object.defineProperty(Element.prototype, 'documentOffsetLeft', {
                configurable: true,
                get: () => {
                    return this.offsetLeft + (this.offsetParent ? this.offsetParent.documentOffsetLeft : 0);
                }
            });

            UiStateStore.update(componentId, (model) => {
                model.bubble.bubblePlaceholder = placeHolder;
            });
        } catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    // Discontinue, no more providing Bubble experience
    static showBubble(event, componentId) {
        event.stopPropagation();

        let render = false;
        UiStateStore.update(componentId, (model) => {
            model.bubble.isBubbleVisible = true;
            model.bubble.position = BubblePositionCalculator.calculatePosition(event);
            render = !model.bubble.isBubbleRendered;
        });

        if (render) {
            UiActions._renderBubble(componentId);
        }
    }

    // Discontinue, no more providing Bubble experience
    static hideBubble(componentId) {
        UiStateStore.update(componentId, (model) => {
            model.bubble.isBubbleVisible = false;
        });
    }

    // Discontinue, no more providing Bubble experience
    static _renderBubble(componentId) {
        UiStateStore.update(componentId, (model) => {
            model.bubble.isBubbleRendered = true;

            ReactDOM.render(
                <LoginBubble componentId={componentId} />,
                model.bubble.bubblePlaceholder
            );
        });
    }

    // Deprecated
    static registerComponent(componentId) {
        ModelStore.registerComponent(componentId);
        ParamStore.registerComponent(componentId);
        UiStateStore.registerComponent(componentId);
    }

    static trackUiEvent(trackingValue, componentId) {
        JmServices.trackEvent(componentId, {trackingValue: trackingValue});
    }

    static showProductInformation(componentId) {
        JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsChooseOtherwiseLinkClicked});
        UiStateStore.update(componentId, (model) => {
            model.form.showProductInformation = true;
        });
    }

    static termsLinkClicked(componentId) {
        JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsTermsLinkClicked});
    }

    static privacyLinkClicked(componentId) {
        JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsPrivacyPolicyLinkClicked});
    }

    static existingLoginLinkClicked(hasPassword, componentId) {
        JmServices.trackEvent(componentId, {
            isAsync: false,
            trackingValue: TrackingAction.jlsAlreadyExistingUserClickedLoginLink
        }).then(() => {
            UiActions._openLoginView(hasPassword, componentId);
        }).catch(() => {
            UiActions._openLoginView(hasPassword, componentId);
        });
    }

    static federatedLoginLinkClicked(clsLoginUrl, componentId) {
        // Aspirin needed for GA page leave tracking as no callback
        window.setTimeout(() => {
            JmServices.trackEvent(componentId, {
                isAsync: false,
                trackingValue: TrackingAction.jlsFederatedUserClickedLoginLink
            }).then(() => {
                UiActions._redirectAfterLinkClicked(clsLoginUrl);
            }).catch(() => {
                UiActions._redirectAfterLinkClicked(clsLoginUrl);
            });
        }, 500);
    }

    static _openLoginView(hasPassword, componentId) {
        if (hasPassword) {
            FormActions.changeFormType(componentId, FormType.login);
        } else {
            // PWD less flow
            FormActions.redirectToForgotPwd(componentId);
        }
    }

    static _redirectAfterLinkClicked(url) {
        window.top.location = url;
    }
}



/** WEBPACK FOOTER **
 ** ./src/logic/ui-actions.js
 **/